export function decodeToken(token) {
  try {
    const payload = token.split(".")[1];
    const json = decodeURIComponent(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function expiresAt(token) {
  const p = decodeToken(token);
  return p?.exp ? p.exp * 1000 : null;
}

export function isExpired(token, skewMs = 5000) {
  const at = expiresAt(token);
  return at === null || Date.now() > at - skewMs;
}
